import { Trans } from 'react-i18next'

import footPNG from '~/assets/images/anatomy/foot.png'
import footWEBP from '~/assets/images/anatomy/foot.webp'
import {
  ANSWERS,
  FOOT_BIOMECHANICS_QUESTION,
  greenAccept,
  redCross,
} from '~/pages/anatomy/quizBinaryChoice/libs/constants'
import { useBinaryChoiceStep } from '~/shared/hooks/useBinaryChoiceStep'
import { TPageProps } from '~/shared/types/commonTypes'

import { Styles as S } from './styles'

const FootBiomechanics = ({ pageId, nextPagePath }: TPageProps) => {
  const { answer, handleAnswer } = useBinaryChoiceStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: FOOT_BIOMECHANICS_QUESTION,
  })

  return (
    <S.Root>
      <S.StyledContainer>
        <div>
          <S.Question>
            <Trans i18nKey="onboarding.quizBinaryChoice.quizWithImageTitle" />
          </S.Question>

          <S.CardWrapper>
            <S.Card>
              <S.ImageBackground>
                <picture>
                  <source srcSet={footWEBP} type="image/webp" />
                  <img src={footPNG} alt="Foot & Biomechanics" />
                </picture>
              </S.ImageBackground>

              <S.CardTextContent>
                <S.CardTitle>
                  <Trans i18nKey="onboarding.quizBinaryChoice.footBiomechanicsTitle" />
                </S.CardTitle>
                <S.CardSubtitle>
                  <Trans i18nKey="onboarding.quizBinaryChoice.footBiomechanicsSubtitle" />
                </S.CardSubtitle>
              </S.CardTextContent>
            </S.Card>
          </S.CardWrapper>
        </div>

        <S.ButtonWrapper>
          <S.StyledButton
            type="button"
            $isSelected={answer === ANSWERS.no}
            onClick={() => handleAnswer(ANSWERS.no)}
          >
            <S.ButtonIcon src={redCross} alt={ANSWERS.no} />
            <Trans i18nKey={`actions.${ANSWERS.no}`} />
          </S.StyledButton>

          <S.StyledButton
            type="button"
            $isSelected={answer === ANSWERS.yes}
            onClick={() => handleAnswer(ANSWERS.yes)}
          >
            <S.ButtonIcon src={greenAccept} alt={ANSWERS.yes} />
            <Trans i18nKey={`actions.${ANSWERS.yes}`} />
          </S.StyledButton>
        </S.ButtonWrapper>
      </S.StyledContainer>
    </S.Root>
  )
}

export default FootBiomechanics
